/* unplugin-vue-components disabled */import script from "./MyView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyView.vue?vue&type=script&setup=true&lang=js"

import "./MyView.vue?vue&type=style&index=0&id=bb1d35b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1d35b4"]])

export default __exports__